/**
 * Single source of truth for Minecraft server connection info, feature flags,
 * and community links. Vanilla and modded are independent services and may be
 * in different lifecycle states.
 */

export type ServerStatusValue = 'coming-soon' | 'online' | 'offline'

export interface ModpackInfo {
  name: string
  version: string
  launcher: 'CurseForge' | 'Modrinth'
  url: string
}

export interface ServerInfo {
  name: string
  host: string
  port: number
  version: string
  description: string
  status: ServerStatusValue
  modpack?: ModpackInfo
}

export interface ServerConfig {
  servers: {
    vanilla: ServerInfo
    modded: ServerInfo
  }
  features: {
    liveStatusEnabled: boolean
    storeEnabled: boolean
    statsEnabled: boolean
  }
  community: {
    discord: string
    steam: string
  }
}

export const serverConfig: ServerConfig = {
  servers: {
    vanilla: {
      name: 'Uliunai Survival',
      host: 'mc.vanilla.uliunai.com',
      port: 25565,
      version: '26.1.2 (latest compatible stable)',
      description:
        'Survival Java with curated server plugins — land claims, economy and shops, rollback, ranks and tags. No client modpack required; performance clients like Sodium are still welcome.',
      status: 'online',
    },
    modded: {
      name: 'Uliunai Modded',
      host: 'mc.modded.uliunai.com (coming soon)',
      port: 25565,
      version: '1.21.1',
      description:
        'A NeoForge 1.21.1 modpack packed with tech, magic, exploration and quality-of-life mods. Build wild contraptions, automate everything, and explore strange new worlds with friends.',
      status: 'coming-soon',
      modpack: {
        name: 'Uliunai Adventures',
        version: '1.21.1 NeoForge',
        launcher: 'CurseForge',
        url: 'https://www.curseforge.com/minecraft/share/lRCwHIMz',
      },
    },
  },
  features: {
    liveStatusEnabled: true,
    storeEnabled: false,
    statsEnabled: false,
  },
  community: {
    discord: 'https://discord.gg/vGX8GSrej6',
    steam: 'https://steamcommunity.com/groups/uliunailt',
  },
}

export default serverConfig
